import {
	AfterViewChecked,
	AfterViewInit,
	Component,
	ElementRef, HostListener,
	Inject,
	OnInit,
	Renderer2,
	ViewChild
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {VehicleModelService} from "../services/vehicle-model.service";
import {TrimModel} from "../model/slicemodel/TrimModel";
import {Incentive} from "../model/slicemodel/Incentive";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {ModelSlice} from "../model/slicemodel/ModelSlice";
import {DatePipe} from '@angular/common';
import {FinanceOffer} from '../model/slicemodel/FinanceOffer';
import {FinanceOffers} from "../model/slicemodel/FinanceOffers";
import {CashOffer} from '../model/slicemodel/CashOffer';
import {Configparams} from "../model/configmodel/configparams";
import {ConfigService} from "../services/config.service";
import {onPaymentEstimatorClickAnalytics, onVehicleClickAnalytics, onApplyOnlineScheduleDriveAnalytics} from "../adobe-analytics/analytics";
import {VehicleSliceEnum} from "../enum/VehicleSliceEnum";
import {LeaseTerm} from '../model/slicemodel/LeaseTerm';
import {LeasePayment} from "../model/slicemodel/LeasePayment";
import {LeaseTerms} from "../model/slicemodel/LeaseTerms";
import {Qauth} from "../model/configmodel/qauth";
import {map} from "rxjs/operators";
import Utils from "../utils/utils";
import {PaymentEstimatorResponse} from "../model/paymentEstimatorResponseModel/paymentEstimatorResponse";
import {
	DOWN_PAYMENT_ADJUSTMENT,
	DOWN_PMT_NET_TRADEIN_ADJUSTMENT,
	NET_TRADEIN_ADJUSTMENT
} from "../utils/constants";
import * as ToolTipConstants from '../utils/constants';

@Component({
	selector: 'paymentestimationwindow',
	templateUrl: './payment-estimation-window.component.html',
	styleUrls: ['./payment-estimation-window.component.scss'],
	standalone: false
})
export class PaymentEstimationWindowComponent implements OnInit, AfterViewInit, AfterViewChecked {
	paymentEstForm: FormGroup;
	calcPopoverTriggers = 'hover';
	vehicleImage: string
	rangeValue: any
	renderSpecialAprRate = false
	renderManualAprRate = false
	vehModel: TrimModel;
	totalIncentiveAmount: any = 0;
	aprStartDate: any
	aprEndDate: any
	appConfig: Configparams
	financeTermsList: number[] = []
	leaseTermsList: number[] = []
	//selectedTermValue: number = 72
	selectedTermValue: number
	monthlyPayment = 0;
	dnd: string;
	sellingPrice: number;
	estimatedNetPrice: number;
	totalAmountFinanced = 0;
	planCode = '1';
	isIncludeIncentiveRate: boolean;
	deposit: string;
	tradeIn = 0
	userRate: string;
	isDefault = false;
	isUserEnteredRate = false;
	defaultFinanceTerm: string;
	totalOption = 0
	@ViewChild("zipCode")
	zipCode: ElementRef;
	@ViewChild("zipCodeText")
	zipCodeText: ElementRef;
	leaseTab: number;
	defaultMilesOrKMPerAnnum: string;
	flag: boolean;
	acquisitionFee: number;
	adjCapCost: number;
	renderSpecialRate = true
	financeDefaultTerm = 72;
	incentiveInfo = ''
	aprInfo = ''
	annualMileValue: string
	annualMileage: string
	isShown = true;
	stateProvinceCode = 'MI';
	zipCodeUpdate = '48120';
	zipCodeForm: any;
	errorMsg: string
	showErrorMsg = false;
	annualMileageList: any = [];
	mileageFlag: boolean;
	defaultMileageDisplay: boolean;
	isSelected: boolean;
	baseMsrp: any
	combinedValue: number;
	vehicleModel: string;
	@ViewChild("incentiveToolTip", {static: false})
	incentiveToolTip: ElementRef
	@ViewChild("leaseIncentiveToolTip", {static: false})
	leaseIncentiveToolTip: ElementRef
	@ViewChild("aprToolTip", {static: false})
	aprToolTip: ElementRef
	@ViewChild("manualAprTooltip", {static: false})
	manualAprTooltip: ElementRef
	@ViewChild("downPaymentValue")
	downPaymentValueElement: ElementRef;
	@ViewChild("tradeInValue")
	tradeInValueElement: ElementRef;
	@ViewChild("leaseDownPaymentValue")
	leaseDownPaymentValueElement: ElementRef;
	@ViewChild("leaseTradeInValue")
	leaseTradeInValueElement: ElementRef;
	@ViewChild("manualAprRate")
	manualAprRate: ElementRef;
	updatedDepositAmount: string;
	updateTradeInAmount: string;
	isUpdateDeposit = false;
	isDisclosureOpen = 'close';
	isLeaseDataExist = false;
	isFinanceDataExist = true;
	leaseSigningAmount = 0;
	updateTotalAmountFinanced: number;
	isRateChange: boolean;
	contentAction: string;
	downPaymentAdjusted = false;
	tradeInAdjusted = false;
	editedValue: string;
	downPaymentCursorPos: any
	moveCursorend: boolean
	authTokenData: Qauth
	cursorPos: any
	loading: boolean
	selectedTab = 0
	monthlyPaymentLoader: boolean;
	checkLoop: boolean;
	isRadioType = true;
	downPaymentValueTOZero: boolean;
	private getModelSliceData: ModelSlice;
	timeOutId: any;
	private readonly DEFAULT_MANUAL_USER_RATE = '5';
	selectedYear: string;
	isDownloadPdfClicked:any
	programId:any
	private readonly OLD_ACQUISITION_FEE: number = 645;
	private readonly NEW_ACQUISITION_FEE: number = 825;
	ToolTipConstants = ToolTipConstants;
	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.updateTriggers(window.innerWidth);
	}

	constructor(private readonly renderer: Renderer2, @Inject(MAT_DIALOG_DATA) public data, private readonly fb: FormBuilder,
				private readonly vehicleService: VehicleModelService, private readonly configService: ConfigService, private readonly dialogRef: MatDialogRef<PaymentEstimationWindowComponent>, private readonly elementRef: ElementRef) {
		this.paymentEstForm = fb.group({
			downPaymentValue: [0, [Validators.required, Validators.pattern("\\$\\d+")]],
			tradeInValue: [0, [Validators.required, Validators.pattern("\\$\\d+")]],
			incentiveValue: 0,
			rateType: '1',
			manualAprRate: '5',
			annualMiles: '10,500'
		});

		this.zipCodeForm = this.fb.group({
			zipCodeInput: ['', Validators.required]
		});

		this.getVehicleImage(data.vehicleimage);
		this.vehModel = data.vehModel;
		this.flag = false;
		this.baseMsrp = data.BaseMsrp;
		this.vehicleModel = data.modelName;
		this.selectedYear = data.selectedYear;
	}

	ngOnInit(): void {
		this.loading = true
		this.CollectAppConfigDetails();
		this.flag = true;
		this.downPaymentValueTOZero = false;
		this.mileageFlag = true;
		this.renderSpecialAprRate = true;
		this.defaultPaymentCalculation()
		this.addTradeInCurrency()
		this.addAPRPercentSymbol();
		this.checkLoop = true;

	}

	ngAfterViewInit() {
		setTimeout(() => {
			console.log('AfterContentInit', false);
			if (this.incentiveToolTip === undefined || this.aprToolTip === undefined) {
				console.log('AfterContentInit', true);
			} else {
				this.incentiveToolTip.nativeElement.setAttribute('data-content', this.incentiveInfo);
				this.aprToolTip.nativeElement.setAttribute('data-content', this.aprInfo);
			}
		}, 5);
	}

	ngAfterViewChecked() {
		if (this.aprToolTip !== undefined) {
			this.aprToolTip.nativeElement.setAttribute('data-content', this.aprInfo);
		}
		if (this.incentiveInfo !== undefined && this.incentiveToolTip !== undefined) {
			this.incentiveToolTip.nativeElement.setAttribute('data-content', this.incentiveInfo);
		}
		if (this.incentiveInfo !== undefined && this.leaseIncentiveToolTip !== undefined) {
			this.leaseIncentiveToolTip.nativeElement.setAttribute('data-content', this.incentiveInfo);
		}
	}

	updateTriggers(screenWidth: number): void {
		this.calcPopoverTriggers = screenWidth <= 768 ? 'click' : 'hover';
		console.log('updating ')
	}
	getIncentiveValue(financeIncentive: Incentive[], leaseIncentive: Incentive) {
		this.totalIncentiveAmount = 0.0;
		if (this.isFinanceTab()) {
			console.log(financeIncentive);
			Object.entries(financeIncentive).filter(value => value[0]?.includes('Amount')).forEach(amount => {
				console.log(amount[1]);
				this.totalIncentiveAmount = +amount[1] + +this.totalIncentiveAmount;
			})
		} else {
			console.log(leaseIncentive);
			console.log(Object.entries(leaseIncentive).filter((value) => typeof value[0]))
			Object.entries(leaseIncentive).filter((value) => value[0]?.includes('Amount')).forEach((amount) => {
				console.log(amount[1]);
				this.totalIncentiveAmount = +amount[1] + +this.totalIncentiveAmount;
			});
		}
		this.paymentEstForm.controls['incentiveValue'].setValue(this.totalIncentiveAmount);
	}

	highlightTermSelection(termValue: number) {
		this.selectedTermValue = termValue;
		this.contentAction = this.isLeaseTab() ? 'lease:terms:' + this.selectedTermValue + ' months' :
			'finance:terms:' + this.selectedTermValue + ' months';
		if (!this.flag) {
			this.showErrorMsg = false;
			this.checkLoop = true;
			this.clearSvg(this.downPaymentValueElement, this.tradeInValueElement);
			this.defaultPaymentCalculation();
		}
	}

	getVehicleImage(imageToken: string) {
		console.log('imageToken:' + imageToken)
		this.vehicleImage = this.vehicleService.digUrl(imageToken, 'HD-TILE', 'EXT', 5);
	}

	onchangeRateType() {
		this.isRateChange = true;
		this.showErrorMsg = false;
		this.selectedTermValue = 72;
		console.log('radio::' + this.paymentEstForm.controls['rateType'].value)
		if (this.paymentEstForm.controls['rateType'].value !== 'undefined' && this.paymentEstForm.controls['rateType'].value === '1') {
			this.renderSpecialAprRate = true;
			this.renderManualAprRate = false;
			this.contentAction = 'finance:special rate';
		}
		if (this.paymentEstForm.controls['rateType'].value !== 'undefined' && this.paymentEstForm.controls['rateType'].value === '2') {
			this.renderManualAprRate = true;
			this.renderSpecialAprRate = false;
			this.contentAction = 'finance:enter apr';
		}
		if (this.paymentEstForm.controls['rateType'].value === '2') {
			this.paymentEstForm.controls['manualAprRate'].setValue('5%')
		}
		this.defaultPaymentCalculation();
	}

	onTabChange($event: MatTabChangeEvent) {
		this.leaseTab = $event.index;
		this.checkLoop = true;
		this.programId='';
		this.isDownloadPdfClicked=false
		this.loading = true;
		this.resetDownPaymentTradeIn();
		console.log('$event.index', $event.index);
		this.showErrorMsg = false;
		this.paymentEstForm.controls['downPaymentValue'].markAsUntouched();
		this.paymentEstForm.controls['tradeInValue'].markAsUntouched();
		if (this.paymentEstForm.controls['rateType'].value === '2') {
			this.isRadioType = false;
			this.paymentEstForm.controls['manualAprRate'].setValue('5%')
		} else {
			this.isRadioType = true;
		}
		this.loadDefaultValues()
		this.addCommaForMiles();
	}

	addDownPaymentCurrency() {
		if (!this.paymentEstForm.controls['downPaymentValue'].value.includes('$')) {
			this.paymentEstForm.controls['downPaymentValue'].setValue('$' + this.paymentEstForm.controls['downPaymentValue'].value)
		}
	}

	addTradeInCurrency() {
		if (this.paymentEstForm.controls['tradeInValue'].value === 0 || !this.paymentEstForm.controls['tradeInValue'].value.includes('$')) {
			this.paymentEstForm.controls['tradeInValue'].setValue('$' + this.paymentEstForm.controls['tradeInValue'].value)
		}
	}

	addAPRPercentSymbol() {
		if (this.paymentEstForm.controls['manualAprRate'].value === 0 || !this.paymentEstForm.controls['manualAprRate'].value.includes('%')) {
			this.paymentEstForm.controls['manualAprRate'].setValue(this.paymentEstForm.controls['manualAprRate'].value + '%')
		}
	}

	validateAprInput(inputhtml: any) {
		const pos = inputhtml.selectionStart;
		const aprArray: [] = this.paymentEstForm.controls['manualAprRate'].value.split('%');

		if (aprArray.length > 1 && aprArray.pop() !== '') {
			this.paymentEstForm.controls['manualAprRate'].setValue(aprArray.reverse().pop() + '%')
		}
		if (aprArray.length > 0) {
			const apr = this.paymentEstForm.controls['manualAprRate'].value
			console.log('apr:' + apr.match(/^-?\d+(?:\.\d{0,2})?/)[0]);
			this.paymentEstForm.controls['manualAprRate'].setValue(apr.match(/^-?\d+(?:\.\d{0,2})?/)[0] + '%')
		}
		inputhtml.selectionStart = inputhtml.selectionEnd = pos;
	}

	formatLimitDecimals(value, decimals) {
		const parts = value.toString().split('.')

		if (parts.length === 2) {
			return Number([parts[0], parts[1].slice(0, decimals)].join('.'))
		} else {
			return Number(parts[0]);
		}
	}

	defaultPaymentCalculation() {
		if (!this.flag) {
			this.monthlyPaymentLoader = true;
		}
		this.vehModel.ModelSlices.ModelSlice.filter(slice => slice.name === this.data.modelName).forEach(modelSlice => {
			this.getModelSliceData = modelSlice;
			const financeOffer = modelSlice.PaymentEstimator.FinanceOffers;
			let leasePayment = modelSlice.PaymentEstimator.LeasePayment;
			const isLeaseExist: any = 'Lease Information not available';
			const currentMake = 'Lincoln ' + modelSlice.make + ' ' + modelSlice.name + ' ' + modelSlice.year;
			const nameplate = 'Lincoln ' + modelSlice.make;
			this.acquisitionFee = this.getCorrectAcquisitionFee(leasePayment);
			this.setAnalyticsData(modelSlice, nameplate, currentMake);
			this.isLeaseDataExist = leasePayment !== isLeaseExist;
			if (leasePayment !== isLeaseExist) {
				leasePayment = this.prepareLeaseData(leasePayment);
			}
			if (this.isFinanceTab()) {
				this.loadUserEnteredRate(financeOffer);
			}
			if (this.isFinanceTab() && typeof financeOffer !== 'undefined'
				&& Object.keys(financeOffer).length !== 0) {
				this.processFinanceTabData(financeOffer);
			} else if (typeof leasePayment !== 'undefined' && this.isLeaseTab() && this.isLeaseDataExist) {
				this.processLeaseTabData(leasePayment);
			}
			if (!this.isLeaseDataExist && this.isLeaseTab()) {
				this.loading = false;
			} else {
				this.getCalculatedValues(modelSlice);
			}
		})
	}
	private getCorrectAcquisitionFee(leasePayment: LeasePayment) {
		return Number(leasePayment.AcquisitionFee) === this.OLD_ACQUISITION_FEE ? this.NEW_ACQUISITION_FEE : Number(leasePayment.AcquisitionFee);
	}

	setAnalyticsData(modelSlice: ModelSlice, nameplate: string, currentMake: string) {
		console.log('modelSlice.name:'+modelSlice.name)
		if (!this.flag && this.checkLoop) {
			onPaymentEstimatorClickAnalytics({
				page: VehicleSliceEnum.page_result,
				formInput: this.selectedYear + ':personal',
				siteSection: VehicleSliceEnum.site_section,
				hierarchy: VehicleSliceEnum.hierarchy,
				rule: VehicleSliceEnum.page_result_rule,
				client: this.appConfig.client,
				site: this.appConfig.site,
				modelYear: modelSlice.year,
				nameplate,
				linkName: VehicleSliceEnum.page_result + ':content action',
				onclick: VehicleSliceEnum.site_section + ':results:content:' + this.contentAction,
				bodyModelTrim: modelSlice.name,
				currentMake
			});
		} else if (!this.checkLoop && this.flag) {
			onVehicleClickAnalytics({
				page: VehicleSliceEnum.page_result,
				formInput: this.selectedYear + ':personal',
				siteSection: VehicleSliceEnum.site_section,
				hierarchy: VehicleSliceEnum.hierarchy,
				rule: VehicleSliceEnum.rule,
				client: this.appConfig.client,
				site: this.appConfig.site,
				modelYear: modelSlice.year,
				nameplate,
				currentMake,
				linkName: VehicleSliceEnum.page_result,
				onclick: VehicleSliceEnum.site_section + ':results'
			});
		}
	}

	private isFinanceTab() {
		return this.leaseTab === 0 || typeof this.leaseTab === 'undefined';
	}

	private prepareLeaseData(leasePayment: LeasePayment) {
		if (leasePayment !== undefined || Object.keys(leasePayment).length !== 0) {
			if (Object.keys(leasePayment.LeaseTerms).length !== 0) {
				this.isLeaseDataExist = true;
			} else {
				//need to check leaseTerm if null
				const leaseTerm: LeaseTerm[] = [];
				if (Object.values(leasePayment.LeaseTerms).every(leaseTerms =>
					(leaseTerms === null || leaseTerms === ''))) {
					leasePayment = {} as LeasePayment;
					leasePayment.LeaseTerms = {} as LeaseTerms;
					leasePayment.LeaseTerms.LeaseTerm = leaseTerm;
				}
				this.isLeaseDataExist = false;
			}
		}
		return leasePayment;
	}

	private processLeaseTabData(leasePayment: LeasePayment) {
		this.totalIncentiveAmount = 0;
		const leaseTerm = leasePayment.DefaultTerm;
		const miles = this.annualMileValue.replace(/,/g, '');
		this.planCode = '2'
		this.defaultMilesOrKMPerAnnum = leasePayment.DefaultAnnualMileage.includes(miles) ? leasePayment.DefaultAnnualMileage : miles;
		this.isDefault = this.selectedTermValue === Number(leaseTerm);
		this.userRate = '5';
		if ('Incentive' in leasePayment.LeaseIncentives) {
			this.getIncentiveValue(null, leasePayment.LeaseIncentives.Incentive);
			this.setLeaseOffer(leasePayment.LeaseIncentives.Incentive)
		} else {
			this.incentiveInfo = 'No Available Incentives. There currently aren’t any available ' +
				'incentives for the zip code:' + this.zipCodeUpdate + '. If this is the wrong zip code please enter the correct one to check for current incentives. '
			this.leaseIncentiveToolTip.nativeElement.setAttribute('data-content', this.incentiveInfo);
		}
		if (Object.keys(leasePayment.LeaseTerms).length !== 0) {
			leasePayment.LeaseTerms.LeaseTerm.filter(filterTerm => this.selectedTermValue === Number(filterTerm.Term))
				.forEach(terms => (this.userRate = terms.APR));
			this.leaseTermsList = []
			leasePayment.LeaseTerms.LeaseTerm.forEach(terms => (this.leaseTermsList.push(Number(terms.Term))));
			this.leaseTermsList.sort((a, b) => (a - b));
			this.highlightSelectedTerms();
		}

		if (Object.keys(leasePayment.AnnualMileageAdjustments).length !== 0 && this.mileageFlag) {
			leasePayment.AnnualMileageAdjustments.AnnualMileageAdjustment.forEach(annualMileageAdjustment => {
				if (leasePayment.DefaultAnnualMileage.includes(annualMileageAdjustment.Mileage)) {
					this.paymentEstForm.controls['annualMiles'].setValue(annualMileageAdjustment.Mileage);
				}
				this.annualMileageList.push(Number(annualMileageAdjustment.Mileage));

			});
			this.annualMileageList.sort((a, b) => a - b);
			console.log('List mileage', this.annualMileageList)
			this.mileageFlag = false;
		}

		this.paymentEstForm.controls['incentiveValue'].setValue(this.totalIncentiveAmount);
		this.isUserEnteredRate = true;
	}

	financeOfferFilter(FinanceOffer: any) {
		let filteredFinanceOffers
		const selectedTerm = this.selectedTermValue ? this.selectedTermValue : this.financeDefaultTerm
		this.financeTermsList = [];
 		this.userRate = undefined;
		FinanceOffer.FinanceOffer.forEach(
			(financeOffer) => {
				filteredFinanceOffers = this.getSelectedFinanceOffer(financeOffer, selectedTerm, filteredFinanceOffers);
			});
		filteredFinanceOffers = {
			FinanceOffer: filteredFinanceOffers
		}
		return filteredFinanceOffers;
	}

	getSelectedFinanceOffer(financeOffer, selectedTerm: number, filterFinanceOffer) {
		financeOffer.APRTerms.APRTerm.forEach(
			(aprTerm) => {
				this.financeTermsList.push(Number(aprTerm.Term));
				if (selectedTerm === Number(aprTerm.Term)) {
					if (this.userRate === undefined || Number(aprTerm.APR) < Number(this.userRate)) {
						this.userRate = aprTerm.APR;
						filterFinanceOffer = financeOffer;
					}
				}
			})
		return filterFinanceOffer;
	}

	processFinanceTabData(financeOffer: FinanceOffers) {
		const filterFinanceOffer = this.financeOfferFilter(financeOffer)
		this.setFinanceOfferValues(filterFinanceOffer);
		if (Object.keys(filterFinanceOffer.FinanceOffer.Incentives).length !== 0) {
			const incentiveValue = filterFinanceOffer.FinanceOffer.Incentives.Incentive;
			this.getIncentiveValue(incentiveValue, null);
		} else {
			this.totalIncentiveAmount = 0.0;
		}
		console.log('this.renderspecial rate', this.renderSpecialAprRate);

		if (this.renderSpecialAprRate) {
			this.financeTermsList = [...new Set(this.financeTermsList)].sort((a, b) => a - b);
			this.highlightSelectedTerms();
		} else {
			this.userRate = this.paymentEstForm.controls["manualAprRate"].value.split("%", 1)[0];
		}

		this.isDefault = ((this.flag && this.renderSpecialAprRate) || (this.renderManualAprRate && this.selectedTermValue === 72));
	}

	private getCalculatedValues(modelSlice: ModelSlice) {
		this.getPaymentDetails(modelSlice);
		this.getMonthlyPayment(modelSlice);
		this.updateIfNoIncentiveToolTipData();
	}

	setLeaseOffer(leaseOffer: Incentive) {
		let disclaimer;
		let name;
		let amount;
		let startDate;
		let expiryDate;
		const datePipe = new DatePipe("en-US");
		console.log('lease:::'+Object.entries(leaseOffer))
		Object.entries(leaseOffer).forEach(([key, value]) => {
			console.log('keys:::'+key)
			if (key.includes('Disclaimer')) {
				disclaimer = value
			} else if (key.includes('Name')) {
				name = value
			} else if (key.includes('Amount')) {
				console.log('value::'+value)
				amount = value
			} else if (key.includes('StartDate')) {
				startDate = value
			} else if (key.includes('ExpiryDate')) {
				expiryDate = value
			}
			else if (key.includes('Id')) {
				this.programId = value
			}
		})
		this.setIncentiveInfo(startDate, datePipe, expiryDate, disclaimer, name, amount);
		this.leaseIncentiveToolTip.nativeElement.setAttribute('data-content', this.incentiveInfo);
	}

	private setIncentiveInfo(startDate, datePipe: DatePipe, expiryDate, disclaimer, name, amount) {
		startDate = datePipe.transform(startDate, 'MM/dd/yyyy');
		expiryDate = datePipe.transform(expiryDate, 'MM/dd/yyyy');
		this.incentiveInfo = disclaimer + ' ' + name + ' $' + Math.round(Number(amount)) + ' Offer Valid ' + startDate + '-' + expiryDate
	}

	private setFinanceOfferValues(financeOffer: FinanceOffers) {
		let disclaimer;
		let name;
		let amount;
		let startdate;
		let expiryDate;
		const datePipe = new DatePipe("en-US");
		this.aprStartDate = datePipe.transform(financeOffer.FinanceOffer.StartDate, 'MM/dd/yyyy');
		this.aprEndDate = datePipe.transform(financeOffer.FinanceOffer.EndDate, 'MM/dd/yyyy');
		console.log('financeOffer.FinanceOffer.Incentives', financeOffer.FinanceOffer,
			Object.keys(financeOffer.FinanceOffer.Incentives).length !== 0);
		this.programId=financeOffer.FinanceOffer.ProgramId
		if (Object.keys(financeOffer.FinanceOffer.Incentives).length !== 0) {
			Object.entries(financeOffer.FinanceOffer.Incentives.Incentive).forEach(([key, value]) => {
				if (key.includes('Disclaimer')) {
					disclaimer = value
				} else if (key.includes('Name')) {
					name = value
				} else if (key.includes('Amount')) {
					amount = value
				} else if (key.includes('StartDate')) {
					startdate = value
				} else if (key.includes('ExpiryDate')) {
					expiryDate = value
				}
			})
			this.setIncentiveInfo(startdate, datePipe, expiryDate, disclaimer, name, amount);
		} else {
			this.updateIfNoIncentiveToolTipData();
		}
		this.aprInfo = financeOffer.FinanceOffer.Disclaimer;

	}

	highlightSelectedTerms() {
		if (this.flag) {
			this.highlightTermSelection(this.isFinanceTab() ?
				this.financeDefaultTerm : this.selectedTermValue);
			this.flag = false;
		}
	}

	loadUserEnteredRate(financeOffer: FinanceOffers) {

		if (this.paymentEstForm.controls['manualAprRate'].value.includes('%')) {
			this.userRate = (this.paymentEstForm.controls['manualAprRate'].value).split('%', 1)[0]
		} else {
			this.userRate = this.paymentEstForm.controls['manualAprRate'].value
		}
		if (typeof financeOffer === 'undefined' ||
			Object.keys(financeOffer).length === 0) {
			this.checkFinanceRates(financeOffer);
		}
	}

	private checkFinanceRates(financeOffer: FinanceOffers) {

		console.log('User defined rates', this.userRate);
		this.renderSpecialAprRate = false;
		this.renderManualAprRate = true;
		this.renderSpecialRate = false;
		this.paymentEstForm.controls['rateType'].setValue('2')
		this.isRadioType = true;
	}

	loadManualAprList() {
		this.financeTermsList = []
		this.financeTermsList.push(36, 48, 60, 72, 84)
		this.highlightSelectedTerms();
	}

	loadDefaultValues() {
		if (this.isLeaseTab()) {
			this.selectedTab = 1
			this.selectedTermValue = 36
			this.annualMileValue = this.paymentEstForm.controls['annualMiles'].value;
			this.annualMileage = this.paymentEstForm.controls['annualMiles'].value;
			console.log('Annual miles : ', this.annualMileValue);
			this.leaseTermsList = [];
			this.downPaymentValueTOZero = false;
			this.contentAction = "lease";
		}
		if (this.leaseTab === 0) {
			this.selectedTermValue = 72;
			this.planCode = '1';
			this.selectedTab = 0
			this.contentAction = "finance";
		}
		this.defaultPaymentCalculation()
	}

	private isLeaseTab() {
		return this.leaseTab === 1;
	}

	get zipFormControl() {
		return this.zipCodeForm.controls;
	}

	updateIfNoIncentiveToolTipData() {
		if (this.totalIncentiveAmount === 0) {
			this.incentiveInfo = 'No Available Incentives. There currently aren’t any available incentives for the zip code:' + this.zipCodeUpdate + '. If this is the wrong zip code please enter the correct one to check for current incentives. '
		}
	}

	loadZipcodeData() {
		this.isShown = !this.isShown;
		console.log('zip:' + this.zipCodeForm.controls['zipCodeInput'].value)
		this.zipCodeForm.controls['zipCodeInput'].setValue(this.zipCodeUpdate);
		this.contentAction = "change zip code";
	}

	annualMileChangeListener() {
		this.annualMileValue = this.paymentEstForm.controls['annualMiles'].value;
		console.log(' this.paymentEstForm.controls[\'annualMiles\'].value.toLocaleString():' + Number(this.paymentEstForm.controls['annualMiles'].value).toLocaleString())
		this.annualMileage = Number(this.paymentEstForm.controls['annualMiles'].value).toLocaleString();
		this.contentAction = this.isLeaseTab() ? 'lease:annual miles:' + this.annualMileValue : 'finance:annual miles:' + this.annualMileValue;
		if (!this.flag) {
			this.showErrorMsg = false;
			this.checkLoop = true;
			this.clearSvg(this.downPaymentValueElement, this.tradeInValueElement);
		}
		this.defaultPaymentCalculation();
	}

	addCommaForMiles() {
		this.annualMileValue = this.paymentEstForm.controls['annualMiles'].value;
		console.log(' this.paymentEstForm.controls[\'annualMiles\'].value.toLocaleString():' + Number(this.paymentEstForm.controls['annualMiles'].value).toLocaleString())
		this.annualMileage = Number(this.paymentEstForm.controls['annualMiles'].value).toLocaleString();
		this.contentAction = this.isLeaseTab() ? 'lease:annual miles:' + this.annualMileValue : 'finance:annual miles:' + this.annualMileValue;
		if (!this.flag) {
			this.showErrorMsg = false;
			this.clearSvg(this.downPaymentValueElement, this.tradeInValueElement);
		}
	}

	updateZipCode() {
		this.zipCodeUpdate = this.zipFormControl.zipCodeInput.value;
		console.log('this.zipCodeUpdate', this.zipCodeUpdate);
		if (this.zipCodeUpdate !== '') {
			this.vehicleService.validateZipCode(this.appConfig.modelsliceUrlBase1, this.vehModel.ModelName,
				this.vehModel.Year, this.zipCodeUpdate)
				.pipe(map((data) => Utils.convertNasapiObjectTypesToArrays(data)))
				.subscribe({
					next: (modelSliceResponse) => {
						console.log('response.Response.status::' + modelSliceResponse.Response.status)
						this.showErrorMsg = false
						this.isShown = !this.isShown;
						console.table(this.zipCodeForm.value);
						this.vehModel = modelSliceResponse.Response.Model;
						let modelSlice: ModelSlice;
						console.log('this.vehModel.ModelSlices.ModelSlice', this.vehModel.ModelSlices.ModelSlice);
						this.vehModel.ModelSlices.ModelSlice.forEach((model) => {
							modelSlice = model;
							modelSlice.year = this.vehModel.Year;
							modelSlice.make = this.vehModel.ModelName
							console.log('updated modelSlice', modelSlice,);
						})
						this.vehicleService.getPostalCodeData(this.zipCodeUpdate).subscribe((postalCodeResp) => {
							this.stateProvinceCode = postalCodeResp.Response.PostalCode.States.State.content;
							console.log('updated slice', this.vehModel,);
							const financeOffer = modelSlice.PaymentEstimator.FinanceOffers;
							if (typeof financeOffer === 'undefined' ||
								Object.keys(financeOffer).length === 0) {
								this.checkFinanceRates(financeOffer);
							} else {
								this.renderSpecialAprRate = true;
								this.renderManualAprRate = false;
								this.renderSpecialRate = true;
								this.paymentEstForm.controls['rateType'].setValue('1')
							}
							this.totalIncentiveAmount = 0;
							this.defaultPaymentCalculation();
							this.contentAction = "change zip code";

						});
					},
					error: (err) => {
						this.setErrorMsg('zip code')
					}
				})
		} else {
			this.setErrorMsg('zip code')
		}
		this.updateIfNoIncentiveToolTipData()
	}

	async updateAmountFinanced(b: boolean, editedValue: string) {
		this.showErrorMsg = false;
		if (!this.paymentEstForm.valid) {
			this.setErrorScenarioInUI();
		} else {
			this.isUpdateDeposit = b;
			this.editedValue = editedValue;
			this.checkLoop = true;
			setTimeout(() => {
				this.defaultPaymentCalculation();
				console.log('this.downPaymentAdjusted:' + this.errorMsg)
				if (this.errorMsg.includes('down payment to meet')) {
					this.downPaymentValueElement.nativeElement.style.setProperty('background-image', 'url("finance/payment-calculator/assets/image/i-ball.svg")')
					this.tradeInValueElement.nativeElement.style.removeProperty('background-image');
				}
				if (this.errorMsg.includes('trade-in to meet')) {
					this.tradeInValueElement.nativeElement.style.setProperty('background-image', 'url("finance/payment-calculator/assets/image/i-ball.svg")')
					this.downPaymentValueElement.nativeElement.style.removeProperty('background-image');
				}
				if (this.errorMsg.includes('down payment and trade-in to meet')) {
					this.tradeInValueElement.nativeElement.style.setProperty('background-image', 'url("finance/payment-calculator/assets/image/i-ball.svg")')
					this.downPaymentValueElement.nativeElement.style.setProperty('background-image', 'url("finance/payment-calculator/assets/image/i-ball.svg")')
				}
				if (!this.showErrorMsg) {
					this.downPaymentValueElement.nativeElement.style.removeProperty('background-image');
					this.tradeInValueElement.nativeElement.style.removeProperty('background-image');
				}
			}, 2000)
		}

	}

	private setErrorScenarioInUI() {
		if (this.isLeaseTab()) {
			console.log("im in lease tab ");
			this.downPaymentValueElement = this.leaseDownPaymentValueElement;
			this.tradeInValueElement = this.leaseTradeInValueElement;
		}
		if (!this.paymentEstForm.controls['downPaymentValue'].valid && !this.paymentEstForm.controls['tradeInValue'].valid) {
			this.downPaymentValueElement.nativeElement.style.setProperty('background-image',
				'url("finance/payment-calculator/assets/image/i-ball.svg")');
			this.tradeInValueElement.nativeElement.style.setProperty('background-image',
				'url("finance/payment-calculator/assets/image/i-ball.svg")');
			this.setErrorMsg('down payment and trade-in');
		} else if (!this.paymentEstForm.controls['downPaymentValue'].valid || !this.paymentEstForm.controls['tradeInValue'].valid) {
			return;
		} else {
			this.removeErrorMsg(this.downPaymentValueElement);
			this.removeErrorMsg(this.tradeInValueElement);
		}
	}

	setErrorMsg(val) {
		console.log("692");
		this.errorMsg = 'Please enter a valid ' + val + '.';
		this.showErrorMsg = true
		if (val != null && val === 'trade-in') {
			this.paymentEstForm.controls['tradeInValue'].setValue('$0');
		} else if (val != null && val === 'down payment') {
			this.paymentEstForm.controls['downPaymentValue'].setValue('$0');
		}
	}

	removeErrorMsg(element: ElementRef) {
		element.nativeElement.style.removeProperty('background-image');
		this.showErrorMsg = false;
	}

	CollectAppConfigDetails() {//To load configuration from config file based on US/CA
		this.appConfig = this.configService.getAppConfigValue();
		// console.log("Region::::::" + this.appConfig.region)
	}

	printPDF() {
		this.isDownloadPdfClicked= true;
		let printWindow;
		let printVehicleInfo
		if (this.isLeaseTab()) {
			printWindow = document.getElementById('printLeaseFrame');
			printVehicleInfo = document.getElementById('printVehicleLeaseInfo').innerHTML
		} else {
			printWindow = document.getElementById('printFrame');
			printVehicleInfo = document.getElementById('printVehicleInfo').innerHTML
		}
		console.log('printVehicleInfo::' + printVehicleInfo)
		const doc = printWindow.contentWindow.document;
		doc.open();
		doc.write('<html><head>');
		this.writePDFContent(doc, printVehicleInfo)
		doc.close();
		printWindow = printWindow.contentWindow;
		// tslint:disable-next-line:only-arrow-functions
		setTimeout(function () {
			printWindow.focus();
			printWindow.print();
		}, 1000);
		const currentMake = 'Lincoln ' + this.getModelSliceData.make + ' ' + this.getModelSliceData.name + ' ' + this.getModelSliceData.year;
		const nameplate = 'Lincoln ' + this.getModelSliceData.make;
		const print: string = this.isLeaseTab() ? 'lease print' : 'finance print';
		console.log('this.getModelSliceData.name::'+this.getModelSliceData.name)
		onPaymentEstimatorClickAnalytics({
			page: VehicleSliceEnum.page_result,
			formInput: this.selectedYear,
			siteSection: VehicleSliceEnum.site_section,
			hierarchy: VehicleSliceEnum.hierarchy,
			rule: VehicleSliceEnum.page_result_rule,
			client: this.appConfig.client,
			site: this.appConfig.site,
			modelYear: this.getModelSliceData.year,
			nameplate,
			linkName: VehicleSliceEnum.page_result + ':content action',
			onclick: VehicleSliceEnum.site_section + ':results:content:' + print,
			bodyModelTrim: this.getModelSliceData.name,
			currentMake
		});
	}

	writePDFContent(doc, printVehicleInfo) {

		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 0
		});
		const mothlypayment = formatter.format(this.monthlyPayment)
		const baseMsrp = formatter.format(Math.round(this.baseMsrp));
		const dnd = formatter.format(Math.round(Number(this.dnd)))
		const totalIncentiveAmount = formatter.format(Math.round(this.totalIncentiveAmount))
		const tradeInValue = formatter.format(Math.round(this.tradeIn))
		const totalOption = formatter.format(0)
		const downPayment = formatter.format(Math.round(Number(this.deposit)))
		const amountFinanced = formatter.format(Math.round(Number(this.totalAmountFinanced)))
		let leasesigningprice = formatter.format(this.leaseSigningAmount)
		let monthlyPayment;
		let totalcost;
		let estimatedpricelabel;
		let leasesigningvalue;
		let acquisitionfee;
		let acquisitionfeelabel;
		let sellingPrice
		let incentiveInfo = '';
		let emptyspace = ''
		let estnetprice = ''
		let estnetpricevalue = ''
		let four = ''
		let twelve = ''
		let leaseemptyspace = ''
		if (!this.incentiveInfo.includes('No Available Incentives')) {
			incentiveInfo = this.incentiveInfo;
			emptyspace = '&nbsp';
		}
		let aprinfo = ''
		let six = ''
		let nine = ''
		let financeamtlabel = ''
		let rateTypePDF = ''
		if (this.isLeaseTab()) {
			financeamtlabel = 'ADJUSTED CAPATILIZED COST: '
			monthlyPayment = this.selectedTermValue + ' MONTH LEASE, ' + this.annualMileage + ' MILES '
			totalcost = 'ADJUSTED CAPATILIZED COST'
			estimatedpricelabel = 'ESTIMATED CAPATILIZED COST'
			leasesigningvalue = 'ESTIMATED CASH DUE AT LEASE SIGNING'
			acquisitionfee = formatter.format(Math.round(this.acquisitionFee))
			acquisitionfeelabel = 'ACQUISITION FEE'
			sellingPrice = formatter.format(Math.round(this.sellingPrice + this.acquisitionFee))
			four = '11'
			twelve = '13'
			nine = '12'
			if (!this.incentiveInfo.includes('No Available Incentives')) {
				leaseemptyspace = '&nbsp'
			}
		} else {
			if (this.paymentEstForm.controls['rateType'].value === '2') {
				rateTypePDF = 'Enter your Own ';
			} else {
				rateTypePDF = 'Special Rate ';
			}
			financeamtlabel = 'TOTAL FINANCED AMOUNT: '
			monthlyPayment = this.selectedTermValue + ' MONTH TERM, ' + rateTypePDF + this.userRate + '% APR';
			totalcost = 'AMOUNT FINANCED'
			estimatedpricelabel = 'ESTIMATED SELLING PRICE'
			estnetprice = 'ESTIMATED NET PRICE'
			leasesigningvalue = ''
			acquisitionfee = ''
			acquisitionfeelabel = ''
			leasesigningprice = ''
			estnetpricevalue = '-' + String(formatter.format(Math.round(this.estimatedNetPrice)))
			sellingPrice = formatter.format(Math.round(this.sellingPrice))
			six = '6'
			nine = '9'
			aprinfo = this.aprInfo
		}
		doc.write('<style>.vehicle-image-navigator{margin-bottom: 5px;margin-top: -140px}.zonetwospace{line-height: 25px}.monthTerm{  width: 299px;color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-weight:normal;font-size: 25px;letter-spacing: 1.84px;text-align: center;line-height: 40px}.alignleft{display:inline-block;color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-size: 21px;letter-spacing: 1.54px;line-height: 40px;}.bordertopbot{margin-bottom: 10px;margin-top: 10px; border-top: 1.5px solid #979797; border-bottom: 1.5px solid #979797;text-align: left}.perMonth{color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-size: 20px;margin-bottom: 5%}.monthlyPricelabel{color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-size: 55px;letter-spacing: 4.76px;margin-top: 50px}.linespace{line-height: 10px}.numbering{font-size: medium;padding-top: -20px}.moveDetailsUp{margin-bottom:0px}.vehicleImageSpace{margin-top: auto;}.columnUp{margin-top: -50px}.rowspace{margin-bottom: 10px}.disclosuresub{font-family: "Lincoln Proxima Nova";font-weight:bold;color: black;font-size: 24px;letter-spacing: 1.23px;}.disclosure{white-space:pre-line;font-family: "Lincoln Proxima Nova";font-weight:normal;color: black;font-size: 20px;letter-spacing: 1.23px;line-height: 30px;}.zoneThreeLableNromal{font-family: "Lincoln Proxima Nova";font-weight:normal;color: black;font-size: 13px;letter-spacing: 1.23px;line-height: 15px;}.incentiveinfo{margin-left: 30px;margin-top:-5px;margin-bottom:10px;width:500px;font-family: "Lincoln Proxima Nova Regular";font-weight:normal;color: black;font-size: 16px;letter-spacing: 1.23px;line-height: 26px;}.zoneThreeLable{width:500px;font-family: "Lincoln Proxima Nova";font-weight:normal;color: black;font-size: 13px;letter-spacing: 1.23px;margin-top: -3px;margin-left: 30px;line-height: 15px}.zoneTwoLable{font-weight:normal;margin-top: 2px;color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-size: 20px;letter-spacing: 1.54px;text-transform: uppercase;margin-bottom: 8px;margin-left: 30px}.vehicleyear{font-weight: normal;color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-size: 23px;letter-spacing: 2.64px;text-transform: uppercase;margin-left: -10px}.vehiclemodel{width: 259px;color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-size: 17px;letter-spacing: 2.29px;text-align: center;text-transform: uppercase}.vehicleyearBlock{text-align: left;margin-bottom: 5%;}.monthlyPayment{height: 5px;color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-size: 20px;font-weight: bold;letter-spacing: 2.64px;line-height: 5px;text-transform: uppercase;text-align: left}.vehiclemake{overflow-wrap: break-word;margin-left: 10px;color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-size: 23px;font-weight: bold;letter-spacing: 2.64px;line-height: 24px;text-transform: uppercase;}.pricing{overflow-wrap: break-word;color: #4D4D4D;font-family: "Lincoln Proxima Nova";font-size: 24px;font-weight: bold;letter-spacing: 2.64px;text-transform: uppercase;}.zonethree-Layout{height: 534px;width: 354px;border-radius: 4px 4px 0 4px;background-color: #FFFFFF;border-right: 18px solid #F3F3F3;border-left: 18px solid #F3F3F3;border-top: 18px solid #F3F3F3;border-bottom: 18px solid #F3F3F3;}.vehicle-image {text-align:center;width: 450px;margin-bottom: 2%;margin-top: -9%}.vehicle-image-navigator {text-align:center;width: 350px;margin-bottom: 2%;margin-top: -4%;}*{ box-sizing: border-box;}.Pricecolumn { width: 100%;padding: 10px;height: auto;text-align: center;float: left}.column1 { float: left;width: 100%;padding: 5px;height: auto;text-align: center}.column2 {float: right;width: 50%;padding: 10px;height: auto;}.row:after { content: "";display: table;clear: both;}.space{margin-top:10px;margin-bottom: -10px}.spacetop{margin-top: 20px;margin-bottom: 10px}.monthlyBorder{min-height: 100px;box-sizing: border-box;border: 1.5px solid #979797;border-radius: 4px 4px 0 4px;}.border{min-height: 150px;border: 1.5px solid #979797;border-spacing:0;background-color: #FFFFFF;}.column3 { float: left;width: 75%;padding: 10px;}.column4 { margin-left: -5px;border-radius: 4px 4px 0 4px;;float: left;width: 25%;padding: 10px;}</style>'
			+ '<div class="row">' +
			'<div class="column1">' + printVehicleInfo + '' +
			'<div ><label class="vehicleyear" >' + this.vehModel.Year + '</label>' +
			'<label class="vehiclemake">LINCOLN ' + this.vehModel.ModelName + '</label>' +
			'</div>' +
			'<div class="space"><label class="vehiclemodel" >' + this.vehicleModel + '</label></div>' +
			'</div>' +
			'<div class=" Pricecolumn bordertopbot  ">' +
			'<div class="centerAlign" ><label class=" alignleft" >' + estimatedpricelabel + ': ' + sellingPrice + '</label><br>' +
			'<label class=" alignleft" >' + financeamtlabel + amountFinanced + '</div></div>' +
			// '<div class="spacetop"><div><label class="monthlyPayment ">ESTIMATED PRICE: '+sellingPrice+'</label></div>'+
			'</div>' +
			'<div class="monthlyBorder column1"><div><label class="monthlyPricelabel" >' + mothlypayment + '</label><label class="perMonth" >/ MO</label></div>' +
			'<div ><label class="monthTerm">' + monthlyPayment + ' </label></div>' +
			'<div ><label class="zoneThreeLable">' + aprinfo + ' </label></div>' +
			'<div><label class="monthlyPayment ">&nbsp;</label></div>' +
			'</div>' +
			'<div><label class="linespace ">&nbsp;</label></div>'
			+ '<div class="row border moveDetailsUp"><div class="column3">' +
			'<div><label class="linespace ">&nbsp;</label></div>' +
			'<div ><label class="zoneTwoLable" >REVIEW FINANCING DETAILS</label></div> ' +
			'<div><label class="linespace ">&nbsp;</label></div>' +
			'<h2 class="zoneThreeLable">BASE MSRP<sup>1</sup></h2>' +
			'<h2 class="zoneThreeLable">TOTAL OPTIONS<sup>2</sup></h2>' +
			'<h2 class="zoneThreeLable">DESTINATION AND DELIVERY CHARGES<sup>3</sup></h2>\n' +
			'<h2 class="zoneThreeLable">' + acquisitionfeelabel + '<sup>' + four + '</sup></h2>\n' +
			'<h2 class="zoneThreeLable">' + estimatedpricelabel + '<sup>4</sup></h2>\n' +
			'<h2 class="zoneThreeLable">AVAILABLE INCENTIVES<sup>5</sup></h2>\n' +
			'<div class="incentiveinfo">' + incentiveInfo + '</div>' +
			'<h2 class="zoneThreeLable">' + estnetprice + '<sup>' + six + '</sup></h2>\n' +
			'<h2 class="zoneThreeLable">NET TRADE-IN VALUE<sup>7</sup></h2>\n' +
			'<h2 class="zoneThreeLable">DOWN PAYMENT<sup>8</sup></h2>\n' +
			'<h2 class="zoneThreeLable">' + totalcost + '<sup>' + nine + '</sup></h2> ' +
			'<h2 class="zoneThreeLable">' + leasesigningvalue + '<sup>' + twelve + '</sup></h2> ' +
			'<div><label class="linespace">&nbsp;</label></div>' +
			'</div>' +
			'<div class="column4">' +
			'<h2 class="zonetwospace"> &nbsp;</h2>' +
			'<h2 class="zoneThreeLableNromal">' +
			baseMsrp + '</h2>' +
			'<h2 class="zoneThreeLableNromal">' + totalOption + '</h2>' +
			'<h2 class="zoneThreeLableNromal">' + dnd + '</h2>' +
			'<h2 class="zoneThreeLableNromal">' + acquisitionfee + '</h2>' +
			'<h2 class="zoneThreeLableNromal">' + sellingPrice + '</h2>' +
			'<h2 class="zoneThreeLableNromal">' + '-' + totalIncentiveAmount + '</h2>' +
			'<div>' + emptyspace + '</div>' +
			'<div>' + emptyspace + '</div>' +
			'<div>' + emptyspace + '</div>' +
			'<div>' + emptyspace + '</div>' +
			'<div>' + leaseemptyspace + '</div>' +
			'<h2 class="zoneThreeLableNromal">' + estnetpricevalue + '</h2>' +
			'<h2 class="zoneThreeLableNromal">' + '-' + tradeInValue + '</h2>' +
			'<h2 class="zoneThreeLableNromal">' + '-' + downPayment + '</h2>' +
			'<h2 class="zoneThreeLableNromal">' + amountFinanced + '</h2>' +
			'<h2 class="zoneThreeLableNromal">' + leasesigningprice + '</h2>' +
			// '<h2 class="zoneThreeLableNromal">' + mothlypayment + '</h2>'+
			'</div>' +
			'</div>' +
			'<div style="page-break-before:always"><label class="linespace ">&nbsp;</label></div>'
			+ '<div class="row rowspace"><h2 class="disclosuresub">Additional Information & Disclosures</h2>' +
			'<div class="row rowspace"><label class="disclosuresub">CONSULT YOUR DEALER FOR ACTUAL PRICE, PAYMENTS, QUALIFICATIONS AND COMPLETE DETAILS.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">This payment estimator is a tool to help you estimate your monthly payments and does not make any representation as to actual payment amounts. The payments calculated using this tool are ESTIMATES ONLY. The information that you enter to use this payment estimator tool are for your estimation and comparison purposes only. ACTUAL PRICES AND PAYMENTS MAY BE DIFFERENT due to local rebates, specials, fees and credit qualifications.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">1. The Base Manufacturer\'s Suggested Retail Price (MSRP) is the price of the vehicle without the Documentation Fee, Destination / Delivery charge, Taxes, Title and Registration or Optional Equipment. The MSRP is the vehicle price as recommended by the “manufacturer” often called the ‘sticker’ or list price. Images shown may not necessarily represent the options selected on any vehicle.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">2. Total of Options: Option pricing is based on MSRP.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">3. Charges associated with getting the vehicle from the manufacturer to the dealership.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">4. The Estimated Selling Price/Estimated Capitalized Cost shown is the Base MSRP plus destination charges and total of options, but does not include service contracts, insurance or any outstanding prior credit balance. Does not include Tax, Title or Registration Fees.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">5. Incentives are available at the time of posting and are subject to change and expiration. Not all incentives can be redeemed together. Restrictions may apply. See your local dealer for complete details.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">6. Estimated Net Price is equal to the Estimated Selling Price of the vehicle less Available Incentives.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">7. The difference between the estimated value and any amount still owing on your trade-in vehicle. The "Trade-In Value" of your vehicle is an estimate, only, and many factors that cannot be assessed without a physical inspection of the vehicle may affect actual value. For purposes of this website, we use the services of a third-party vendor to provide Trade-In Value calculations. While we believe this information is reliable, we are not responsible for and do not guarantee the accuracy or reliability of the information. Please see your local dealer for information regarding actual trade-in availability and value.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">8. Down Payment: The cash amount paid towards the total down payment for the transaction.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">9. Amount Financed is the amount used to determine the Monthly Payment. It is equal to the Estimated Net Price of the vehicle less Net Trade-in Value and Down Payment. </label></div>' +
			'<div class="row rowspace"><label class="disclosure">10. Payments calculated using this tool are ESTIMATES ONLY. ACTUAL PRICES AND PAYMENTS MAY BE DIFFERENT. Financing payment calculations are based on APR and term. NOT ALL BUYERS WILL QUALIFY FOR THE LOWEST LINCOLN AUTOMOTIVE FINANCIAL SERVICES APR. Lease payment calculations are based on term and annual mileage. NOT ALL LESSEES WILL QUALIFY FOR THE LOWEST RED CARPET LEASE PAYMENT. Lease payment based on Lincoln Automotive Financial Services Red Carpet lease. Lessee has the option to purchase the vehicle upon lease termination at a price negotiated with dealer at lease signing or inception. Lessee is responsible for Excess Wear and Use and for Mileage over the “miles per term allowance” as stated below:\n' +
			'$0.15 per mile for vehicles with Base MSRPs up to $30,000\n' +
			'$0.20 per mile for vehicles with Base MSRPs from $30,001 to $49,999\n' +
			'$0.25 per mile for vehicles with Base MSRPs over $50,000\n' +
			'NOT ALL COMMERCIALEASE LESSEES WILL QUALIFY FOR LINCOLN AUTOMOTIVE FINANCIAL SERVICES COMMERCIALEASE FINANCING. See dealer for qualification and complete details.</label></div>' +
			'<div class="row rowspace"><label class="disclosure">11. A charge paid by the lessee to Lincoln Automotive Financial Services to help cover the cost of acquiring and servicing the account.</label></div>'
			+ '<div class="row rowspace"><label class="disclosure">12. Estimated Adjusted Capitalized Cost is the amount used to determine the Estimated Monthly Payment. It is equal to the Estimated Capitalized Cost less Down Payment, Available Incentives, and Net Trade-in Amount.</label></div>'
			+ '<div class="row rowspace"><label class="disclosure">13. The amount to be paid by the lessee prior to or at the signing of the lease or by the delivery of the vehicle. The amount due at signing is after application of all available incentives and rebates. It includes the first month’s payment and any Down Payment/Estimated Net Trade-In Amount.</label></div>'
		)

	}

	validateUserAprValue() {
		const apr = this.paymentEstForm.controls['manualAprRate'].value;
		// console.log('apr:' + apr)
		if (Number(apr.replace('%', '')) > 26) {
			this.manualAprRate.nativeElement.style.setProperty('background-image', 'url("finance/payment-calculator/assets/image/i-ball.svg")');
			this.errorMsg = 'Please enter a number between 0-26.';
			this.showErrorMsg = true;
			this.paymentEstForm.controls['manualAprRate'].setValue(this.DEFAULT_MANUAL_USER_RATE + '%');
		} else {
			this.manualAprRate.nativeElement.style.removeProperty('background-image', 'url("finance/payment-calculator/assets/image/i-ball.svg")');
			this.errorMsg = '';
			this.showErrorMsg = false;
		}
		// this.paymentEstForm.controls['manualAprRate'].setValue(apr+'%')
		this.defaultPaymentCalculation();
	}

	private getPaymentDetails(model: ModelSlice) {
		this.isIncludeIncentiveRate = this.isUserEnteredRate && this.flag ? this.renderManualAprRate : this.renderSpecialAprRate;
		this.dnd = model.Pricing.DestinationDeliveryCharge;
		this.sellingPrice = +model.Pricing.BaseMSRP + +this.dnd;
		this.estimatedNetPrice = +this.sellingPrice - +this.totalIncentiveAmount;
		if (this.paymentEstForm.controls['downPaymentValue'].untouched && this.paymentEstForm.controls['downPaymentValue'].pristine
			&& this.paymentEstForm.controls['tradeInValue'].untouched && !this.downPaymentValueTOZero) {
			if (this.isLeaseTab()) {
				this.paymentEstForm.controls['downPaymentValue'].setValue('$' + Math.round((10 / 100) * (this.sellingPrice + this.acquisitionFee)));
			} else {
				this.paymentEstForm.controls['downPaymentValue'].setValue('$' + Math.round((10 / 100) * this.sellingPrice));
			}
		}
		if (this.paymentEstForm.controls['tradeInValue'].untouched && this.paymentEstForm.controls['tradeInValue'].pristine) {
			this.addTradeInCurrency();
		}

		this.defaultFinanceTerm = String(this.selectedTermValue);
		this.setTradeInAndDeposit();
		if (this.renderManualAprRate) {
			this.loadManualAprList()
		}
		console.log('error msg::' + this.showErrorMsg)
	}

	private setTradeInAndDeposit() {
		if (this.isUpdateDeposit) {
			this.uiValidationDownPaymentTradeIn();
			this.paymentEstForm.controls['downPaymentValue'].setValue('$' + this.deposit);
			this.paymentEstForm.controls['tradeInValue'].setValue('$' + this.tradeIn);
			this.calculateAmountFinance();
			if (!this.downPaymentAdjusted) {
				this.downPaymentValueElement.nativeElement.style.removeProperty('background-image');
			}
			if (!this.tradeInAdjusted) {
				this.tradeInValueElement.nativeElement.style.removeProperty('background-image');
			}

		} else {
			this.tradeIn = this.paymentEstForm.controls['tradeInValue'].value.substring(1);
			this.deposit = this.paymentEstForm.controls['downPaymentValue'].value.substring(1);
			this.setTotalAmountFinanced(this.tradeIn, this.deposit);

		}
	}

	private setTotalAmountFinanced(tradeIn, deposit) {
		this.combinedValue = +deposit + +tradeIn;
		if (this.isLeaseTab() && !this.isUpdateDeposit) {
			this.totalAmountFinanced = this.estimatedNetPrice - this.combinedValue + this.acquisitionFee;
		} else if (this.isLeaseTab() && this.isUpdateDeposit) {
			this.updateTotalAmountFinanced = this.estimatedNetPrice - this.combinedValue + this.acquisitionFee;
		} else if (!this.isUpdateDeposit) {
			this.totalAmountFinanced = this.estimatedNetPrice - this.combinedValue;
		}
	}

	private calculateAmountFinance() {
		this.updatedDepositAmount = this.paymentEstForm.controls['downPaymentValue'].value.substring(1);
		this.updateTradeInAmount = this.paymentEstForm.controls['tradeInValue'].value.substring(1);
		this.setTotalAmountFinanced(this.updateTradeInAmount, this.updatedDepositAmount);
	}

	private getMonthlyPayment(modelSlice: ModelSlice) {
		if (Object.values(modelSlice.PaymentEstimator.FinanceOffers).every(financeOffers => (financeOffers === null || financeOffers === ''))) {
			type financeOffers = {
				FinanceOffer: FinanceOffer
			}
			modelSlice.PaymentEstimator.FinanceOffers = {} as financeOffers;
		}

		if (Object.values(modelSlice.PaymentEstimator.CashOffers).every(cashOffers => (cashOffers === null || cashOffers === ''))) {
			type CashOffers = {
				CashOffer: CashOffer
			}
			modelSlice.PaymentEstimator.CashOffers = {} as CashOffers;
		}

		if (this.renderManualAprRate) {
			this.userRate = this.userRate.split('%', 1)[0];
		}

		this.makeBackendCall(modelSlice);
		this.isDownloadPdfClicked= false;
	}

	private makeBackendCall(modelSlice: ModelSlice) {
		this.vehicleService.getDefaultMonthlyPayment({
			modelSlice,
			dnd: this.dnd,
			amount: this.sellingPrice,
			planCode: this.planCode,
			isInclude: this.isIncludeIncentiveRate,
			deposit: this.isUpdateDeposit ? this.updatedDepositAmount : this.deposit,
			userRate: this.userRate,
			term: this.selectedTermValue,
			isDefault: this.isDefault,
			amountFinanced: this.isUpdateDeposit ? this.updateTotalAmountFinanced : this.totalAmountFinanced,
			milesOrKMPerAnnum: this.defaultMilesOrKMPerAnnum,
			zipCode: this.zipCodeUpdate,
			stateProvinceCode: this.stateProvinceCode,
			tradeIn: this.isUpdateDeposit ? +this.updateTradeInAmount : this.tradeIn
		})
			.subscribe((rootPaymentObject) => {
				console.log('calculatePayment', rootPaymentObject);
				this.adjustDownPaymentTradeIn(rootPaymentObject);
				if ("paymentDetails" in rootPaymentObject) {
					rootPaymentObject.paymentDetails.termPaymentDetails.forEach(term => {
						this.acquisitionFee = term.acquisitionFee;
						this.monthlyPayment = term.monthlyPayment;
						this.totalAmountFinanced = term.amountFinanced;
						console.log(this.monthlyPayment, rootPaymentObject);
						this.flag = false;
						this.isUpdateDeposit = false;
						this.setInfoMessageWhenApplicable(rootPaymentObject);
						if (this.isLeaseTab()) {
							this.leaseSigningAmount = term.cashDueAtSigning;
						}
					})
				} else {
					this.isLeaseDataExist = false;
				}
				this.loading = false
				this.monthlyPaymentLoader = false
			});
	}

	private setInfoMessageWhenApplicable(rootPaymentObject: PaymentEstimatorResponse) {
		let downPaymentElementRef;
		let tradeInElementRef;
		if (this.leaseTab === 0) {
			downPaymentElementRef = this.downPaymentValueElement;
			tradeInElementRef = this.tradeInValueElement;
		} else {
			downPaymentElementRef = this.leaseDownPaymentValueElement;
			tradeInElementRef = this.leaseTradeInValueElement;
		}
		// tslint:disable-next-line:max-line-length
		this.paymentEstForm.controls['downPaymentValue'].setValue('$' + Math.floor(rootPaymentObject?.paymentDetails?.termPaymentDetails[0]?.deposit));
		// tslint:disable-next-line:max-line-length
		this.paymentEstForm.controls['tradeInValue'].setValue('$' + Math.floor(rootPaymentObject?.paymentDetails?.tradeInVehicle?.tradeAllowance));
		this.deposit = this.paymentEstForm.controls['downPaymentValue'].value.replace('$', '');
		this.tradeIn = this.paymentEstForm.controls['tradeInValue'].value.replace('$', '');
		const infoMessage = rootPaymentObject?.paymentDetails?.termPaymentDetails[0]?.infoMessage;

		if (infoMessage !== undefined && (infoMessage === DOWN_PAYMENT_ADJUSTMENT)) {
			this.displayDownPaymentError(downPaymentElementRef, tradeInElementRef);
		} else if (infoMessage !== undefined && (infoMessage === NET_TRADEIN_ADJUSTMENT)) {
			this.displayTradeInError(downPaymentElementRef, tradeInElementRef);
		} else if (infoMessage !== undefined && (infoMessage === DOWN_PMT_NET_TRADEIN_ADJUSTMENT)) {
			this.displayDownPaymentAndTradeInError(downPaymentElementRef, tradeInElementRef);
		}
	}

	private adjustDownPaymentTradeIn(rootPaymentObject: any[] | PaymentEstimatorResponse) {
		this.totalAmountFinanced = this.estimatedNetPrice - (+this.deposit + +this.tradeIn);
	}

	private uiValidationDownPaymentTradeIn() {
		let cashLimit: number;
		let downPaymentVal;
		let tradeInVal;
		let totalCash: number;
		let netPrice;
		let downPaymentElementRef: ElementRef<any>;
		let tradeInElementRef: ElementRef<any>;
		let infoMessage: string;
		if (this.isLeaseTab()) {
			downPaymentElementRef = this.leaseDownPaymentValueElement;
			tradeInElementRef = this.leaseTradeInValueElement;
			netPrice = this.estimatedNetPrice + this.acquisitionFee;
			cashLimit = netPrice * 0.30;
		} else {
			downPaymentElementRef = this.downPaymentValueElement;
			tradeInElementRef = this.tradeInValueElement;
			cashLimit = this.estimatedNetPrice - 8000;
			netPrice = this.estimatedNetPrice;
		}
		downPaymentVal = (downPaymentElementRef.nativeElement.value).replace('$', '');
		tradeInVal = (tradeInElementRef.nativeElement.value).replace('$', '');
		totalCash = +downPaymentVal + +tradeInVal;
		this.updateTotalAmountFinanced = netPrice - totalCash;
		if (totalCash >= cashLimit && this.checkLoop) {
			let overage = totalCash - cashLimit;
			if (+downPaymentVal >= overage) {
				downPaymentVal = downPaymentVal - overage;
				this.paymentEstForm.controls['downPaymentValue'].setValue('$' + +downPaymentVal);
				this.deposit = this.paymentEstForm.controls['downPaymentValue'].value.replace('$', '');
				infoMessage = 'DOWN_PAYMENT_ADJUSTMENT';
				this.paymentEstForm.controls['tradeInValue'].setValue(this.paymentEstForm.controls['tradeInValue'].value)
				this.tradeIn = this.paymentEstForm.controls['tradeInValue'].value.replace('$', '');
				this.downPaymentValueTOZero = true;
			} else {
				//need to adjust both downPayment and netTradeinAmount
				overage -= downPaymentVal;
				if (downPaymentVal > 0) {
					downPaymentVal = 0;
					infoMessage = 'DOWN_PAYMENT_ADJUSTMENT';
					this.downPaymentValueTOZero = true;
				}

				if (tradeInVal >= overage) {
					console.log('Trade in check')
					tradeInVal -= overage;
					infoMessage = this.transformInfoMessage(infoMessage);
				} else if (tradeInVal > 0) {
					tradeInVal = 0;
					infoMessage = this.transformInfoMessage(infoMessage);
				}
				this.paymentEstForm.controls['downPaymentValue'].setValue('$' + +downPaymentVal);
				this.paymentEstForm.controls['tradeInValue'].setValue('$' + +tradeInVal);
				this.deposit = this.paymentEstForm.controls['downPaymentValue'].value.replace('$', '');
				this.tradeIn = this.paymentEstForm.controls['tradeInValue'].value.replace('$', '');

			}
			this.setErrorElementRefAccordingly(infoMessage, downPaymentElementRef, tradeInElementRef);

			this.showErrorMsg = true;
			this.checkLoop = false;
		} else {
			this.setDepositTradeInFromUi(downPaymentElementRef, tradeInElementRef);
		}

		this.checkAndSetForLeaseTab(downPaymentElementRef, tradeInElementRef);
		console.log("End:", this.deposit, this.tradeIn, this.paymentEstForm.controls['tradeInValue'].value)
	}

	private checkAndSetForLeaseTab(downPaymentElementRef: ElementRef<any>, tradeInElementRef: ElementRef<any>) {
		if (this.isLeaseTab()) {
			this.downPaymentValueElement = downPaymentElementRef;
			this.tradeInValueElement = tradeInElementRef;
		}
	}

	setDepositTradeInFromUi(downPaymentElementRef: ElementRef<any>, tradeInElementRef: ElementRef<any>) {
		if (this.checkLoop) {
			this.deposit = this.paymentEstForm.controls['downPaymentValue'].value.replace('$', '');
			this.tradeIn = this.paymentEstForm.controls['tradeInValue'].value.replace('$', '');
			this.checkLoop = false;
		}
		this.clearSvg(downPaymentElementRef, tradeInElementRef);
	}

	setErrorElementRefAccordingly(infoMessage: string, downPaymentElementRef: ElementRef<any>, tradeInElementRef: ElementRef<any>) {
		if (infoMessage === 'DOWN_PAYMENT_ADJUSTMENT') {
			this.displayDownPaymentError(downPaymentElementRef, tradeInElementRef);
		}
		if (infoMessage === 'NET_TRADEIN_ADJUSTMENT') {
			this.displayTradeInError(tradeInElementRef, downPaymentElementRef);
		}
		if (infoMessage === 'DOWN_PMT_NET_TRADEIN_ADJUSTMENT') {
			this.displayDownPaymentAndTradeInError(downPaymentElementRef, tradeInElementRef);
		}
	}

	transformInfoMessage(infoMessage: string) {
		if (infoMessage === 'DOWN_PAYMENT_ADJUSTMENT') {
			return 'DOWN_PMT_NET_TRADEIN_ADJUSTMENT';
		} else {
			return 'NET_TRADEIN_ADJUSTMENT';
		}
	}

	private clearSvg(downPaymentElementRef: ElementRef<any>, tradeInElementRef: ElementRef<any>) {
		downPaymentElementRef.nativeElement.style.removeProperty('background-image');
		tradeInElementRef.nativeElement.style.removeProperty('background-image');
	}

	displayTradeInError(tiElementRef: ElementRef<any>, dpElementRef: ElementRef<any>) {
		this.tradeInAdjusted = true;
		this.showErrorMsg = true;
		this.errorMsg = 'We have adjusted your trade-in to meet Lincoln Automotive Guidelines.';
	}

	displayDownPaymentError(downPaymentElementRef: ElementRef<any>, tradeInElementRef: ElementRef<any>) {
		this.downPaymentAdjusted = true;
		this.showErrorMsg = true;
		this.errorMsg = 'We have adjusted your down payment to meet Lincoln Automotive Guidelines.';
	}

	displayDownPaymentAndTradeInError(downPaymentElementRef: ElementRef<any>, tradeInElementRef: ElementRef<any>) {
		this.downPaymentAdjusted = true;
		this.tradeInAdjusted = true;
		this.showErrorMsg = true;
		this.errorMsg = 'We have adjusted your down payment and trade-in to meet Lincoln Automotive Guidelines.';
	}

	userAprRateChange() {
		if (this.timeOutId) {
			clearTimeout(this.timeOutId);
		}
		this.timeOutId = setTimeout(() => {
				this.validateUserAprValue();
				this.contentAction = 'finance:enter apr';
			},
			600);
	}

	openDisclosurePanel() {
		console.log('this.isDisclosureOpen:' + this.isDisclosureOpen)
		if (this.isDisclosureOpen === 'close') {
			this.isDisclosureOpen = 'open'
			setTimeout(() => {
					this.scrollToDisclosurePanel()
				},
				100);
		} else if (this.isDisclosureOpen === 'open') {
			this.isDisclosureOpen = 'close'
		}
	}

	scrollToDisclosurePanel() {
		const errorField = this.renderer.selectRootElement('.disclosureContent')
		errorField.scrollIntoView();
	}

	applyOnline() {
		window.open('https://www.lincoln.com/finance/apply', '_blank', 'noopener');
		this.setApplyOnlineOrScheduleTestDriveAnalytics('apply online');
	}

	setApplyOnlineOrScheduleTestDriveAnalytics(contentAction: string)
	{
		this.contentAction = contentAction;
		const nameplate = 'Lincoln ' + this.data.make;
		const currentMake = 'Lincoln ' + this.data.make + ' ' + this.vehicleModel + ' ' + this.data.makeYear;
		let formInput: string;
		if (this.selectedTab === 0) {
			formInput = this.paymentEstForm.controls['rateType'].value === '1' ? 'special rate' : 'Enter your own';
		} else {
			formInput = 'lease';
		}
		const incentives = this.totalIncentiveAmount === 0 ? undefined : '$' + this.totalIncentiveAmount;
		onApplyOnlineScheduleDriveAnalytics({
			linkName: VehicleSliceEnum.page_result + ':content action',
			onclick: VehicleSliceEnum.site_section + ':results:content:' + this.contentAction,
			apr: 'apr:' + this.userRate+'%',
			terms: 'terms in months:' + this.selectedTermValue,
			annualMiles:  this.selectedTab === 1? 'annual miles:' +this.annualMileage: 'N/A',
			downloadPdf: this.isDownloadPdfClicked,
			downPayment: this.deposit,
			incentives,
			tradeIn: this.tradeIn,
			formInput,
			leaseVsOwn: this.selectedTab === 0 ? 'finance' : 'lease',
			bodyModelTrim: this.vehicleModel,
			currentMake,
			modelYear: this.data.makeYear,
			nameplate,
			rule: VehicleSliceEnum.page_result_rule,
		});
	}

	testDrive() {
		window.open('https://www.lincoln.com/finance/have-a-dealer-contact-me', '_blank', 'noopener');
		this.setApplyOnlineOrScheduleTestDriveAnalytics('schedule a test drive');
	}

	contactDealer() {
		window.open('https://www.lincoln.com/finance/have-a-dealer-contact-me', '_blank', 'noopener');
	}

	parseNumber(val: string) {
		return Number(val);
	}

	calcPercentage(val: string) {
		const downPayment = Number(val.replace('$', ''));
		if (this.isLeaseTab()) {
			return Math.round((downPayment / (this.sellingPrice + this.acquisitionFee)) * 100);
		} else {
			return Math.round((downPayment / this.sellingPrice) * 100);
		}
	}

	resetDownPaymentTradeIn() {
		console.log('this.leaseTab === 1', this.leaseTab, this.acquisitionFee);
		if (this.isLeaseTab() && this.isLeaseDataExist) {
			this.leaseDownPaymentValueElement.nativeElement.style.removeProperty('background-image');
			this.leaseTradeInValueElement.nativeElement.style.removeProperty('background-image');
			const estCapCost = this.sellingPrice + this.acquisitionFee;
			this.paymentEstForm.controls['downPaymentValue'].setValue('$' + Math.round(estCapCost / 10));
		} else {
			this.downPaymentValueElement.nativeElement.style.removeProperty('background-image');
			this.tradeInValueElement.nativeElement.style.removeProperty('background-image');
			this.paymentEstForm.controls['downPaymentValue'].setValue('$' + Math.round(this.sellingPrice / 10));
		}
		this.paymentEstForm.controls['tradeInValue'].setValue('0')
		this.addTradeInCurrency();
		this.addDownPaymentCurrency();
		this.errorMsg = '';
		this.leaseSigningAmount = 0;
		this.monthlyPayment = 0;
	}

	formatManualApr() {
		const apr = this.paymentEstForm.controls['manualAprRate'].value.slice(0, -1);
		if (apr.endsWith('.')) {
			this.paymentEstForm.controls['manualAprRate'].setValue(apr.slice(0, -1) + '%')
		}
		if (this.paymentEstForm.controls['manualAprRate'].value === '%') {
			this.paymentEstForm.controls['manualAprRate'].setValue('0%')
		}
		this.contentAction = 'finance:enter apr';
	}

	handleDownPaymentInputValueChange(e) {
		if (this.paymentEstForm.controls['downPaymentValue'].value === ('$')) {
			this.paymentEstForm.controls['downPaymentValue'].setValue('$0');
		}
		const cursorStart = e.target.selectionStart;
		if (cursorStart === this.paymentEstForm.controls['downPaymentValue'].value.length) {
			this.moveCursorend = true
		} else {
			this.moveCursorend = false
		}
		this.cursorPos = cursorStart
		// console.log('first::'+this.moveCursorend)
	}

	handleTradeInInputValueChange(e) {
		if (this.paymentEstForm.controls['tradeInValue'].value === ('$')) {
			this.paymentEstForm.controls['tradeInValue'].setValue('$0');
		}
		const cursorStart = e.target.selectionStart;
		if (cursorStart === this.paymentEstForm.controls['tradeInValue'].value.length) {
			this.moveCursorend = true
		} else {
			this.moveCursorend = false
		}
		this.cursorPos = cursorStart
		// console.log('first::'+this.moveCursorend)
	}

	async adDownPaymentCurrency(e: KeyboardEvent, inputhtml: HTMLInputElement) {
		const isnumber = false;
		setTimeout(() => {
			this.addDownPaymentCurrency();
			if (this.paymentEstForm.controls['downPaymentValue'].value === ('$')) {
				this.paymentEstForm.controls['downPaymentValue'].setValue('$0');
			}
			if (this.isLeaseTab()) {
				this.updateAmountFinanced(true, 'leaseDownPayment')
				this.contentAction = 'lease:down payment';

			} else {
				this.updateAmountFinanced(true, 'financeDownPayment')
				this.contentAction = 'finance:down payment';
			}
		}, 1)
	}

	adTradeInCurrency($event: KeyboardEvent, inputHtml: HTMLInputElement) {
		const isnumber = false;
		setTimeout(() => {
			this.addTradeInCurrency();
			if (this.paymentEstForm.controls['tradeInValue'].value === ('$')) {
				this.paymentEstForm.controls['tradeInValue'].setValue('$0');
			}
			if (this.isLeaseTab()) {
				this.updateAmountFinanced(true, 'leaseTradeIn');
				this.contentAction = 'lease:trade-in';
			} else {
				this.updateAmountFinanced(true, 'financeTradeIn');
				this.contentAction = 'finance:trade-in';
			}
		}, 1)
	}

	downpaymentOnclick() {
		if (this.paymentEstForm.controls['downPaymentValue'].value === ('$')) {
			this.paymentEstForm.controls['downPaymentValue'].setValue('$0')
		}
		if (this.paymentEstForm.controls['tradeInValue'].value === ('$')) {
			this.paymentEstForm.controls['tradeInValue'].setValue('$0')
		}
	}

	OpenEstimateTradeIn() {
		window.open('https://www.intelliprice.com/intellipricedealer/start.htm?dealerid=1141010&VendorBrand=Lincoln&SecondaryLeadSource=Veretech-LV&SecondaryID=LincolnVehiclesOEM&PrimaryLeadSource=Veretech-LV', '_blank', 'noopener')
	}

	triggerMedalliaSurvey(): void {
		window["mdla"] = {triggerPaymentCalculatorSurvey: true}
		const medallia = window['KAMPYLE_ONSITE_SDK'];
		if (medallia && typeof medallia.updatePageView === 'function') {
			medallia.updatePageView();
			console.log("Medallia survey triggered and page view updated")
		}
	}

	closeDialog() {
		this.triggerMedalliaSurvey();
	}
}

